import React, { useState, useEffect, useRef } from 'react';
import ReactCountryFlag from 'react-country-flag';
import styles from './CountryDropdownList.module.scss';
import Earth from '@src/assets/Earth.png';

type Country = {
    name: string;
    alpha2: string;
    alpha3: string;
    numeric: number;
    is_ue: boolean;
    phone_extension: string;
    rank: number;
};

type CountryDropdownProps = {
    title: string;
    width: string;
    options: Country[];
    selected: string;
    onSelect: (value: string) => void;
};

const CountryDropdown: React.FC<CountryDropdownProps> = ({ title, width, options, selected, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(selected);
    
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleSelect = (alpha2: string) => {
        setSelectedCountry(alpha2);
        onSelect(alpha2);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const selectedCountryData = options && options.find(country => country.alpha2 === selectedCountry);
    return (
        <div className={styles.container}>
            <p className={styles.title}>{title}</p>
            <div className={styles.dropdown} style={{ width }} ref={dropdownRef}>
                <div
                    className={styles.dropdownHeader}
                    onClick={() => setIsOpen(!isOpen)}
                    tabIndex={0}
                >
                    {selectedCountryData ?
                        <div className={styles.selectedCountry}>
                            <ReactCountryFlag
                                countryCode={selectedCountryData.alpha2}
                                svg
                                style={{ marginRight: '10px', width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', objectFit: 'cover' }}
                            />
                            <p className={styles.countryName}>{selectedCountryData.name}</p>
                        </div>
                        :
                        <div className={styles.selectedCountry}>
                            <img src={Earth} alt="Earth" style={{ marginRight: '10px', width: '20px', height: '20px' }} />
                            <p className={styles.countryName}>Choisissez un pays</p>
                        </div>
                    }
                    <span className={styles.arrow}>{isOpen ? '▲' : '▼'}</span>
                </div>
                {isOpen && (
                    <ul className={styles.dropdownList}>
                        {options.map(country => (
                            <li
                                key={country.alpha2}
                                className={`${styles.dropdownItem} ${country.alpha2 === selectedCountry ? styles.selected : ''}`}
                                onClick={() => handleSelect(country.alpha2)}
                            >
                                <ReactCountryFlag
                                    countryCode={country.alpha2}
                                    svg
                                    style={{ marginRight: '8px', width: '20px', height: '20px', borderRadius: '50%', overflow: 'hidden', objectFit: 'cover' }}
                                />
                                {country.name}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default CountryDropdown;
